<template>
  <div>
    <div class="products-listing-head plpmenulist content-wrapper">
      <div class="productfilter-mobile products-filtering">
        <div class="collapsible-content">
          <ul>
            <li :class="checkIfClassActive('Alle')">
              <a href="/produkte">Alle</a>
            </li>
            <li
              v-for="menuLists in menuList"
              :key="menuLists.tabname"
              :class="checkIfClassActive(menuLists.tabname)"
            >
              <!-- NOSONAR -->
              <a :href="menuLists.Categoryurl">{{ menuLists.tabname }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <product-details-data v-for="(itemCollection, indexCol) in itemsArray" :key="indexCol">
          <div v-for="(item, index) in itemCollection" :key="index">
            <product-loop
              :position-in-grid="index"
              :columns-count="columnsCount"
              :image-url="item.firstimageurl"
              :product-name="item.productname"
              :product-url="item.producturl"
              :product-category="item.productcategory"
              :product-brand="item.productbrand"
              :list-tittle="item.listtittle"
              :product-sku="item.productsku"
              :product-fullname="item.productfullname"
              :category="item.category"
              :filterdata="item"
              :itemcollection="itemCollection"
              :itemindex="indexCol"
            />
          </div>
        </product-details-data>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'product-details-short',
  props: {
    menuList: {
      type: Array,
      required: false,
      default: () => [{ tabname: 'tabname', Categoryurl: '/produkte/' }],
    },
    productList: {
      type: Array,
      required: true,
    },
  },
  computed: {
    itemsArray() {
      let i = 0;
      const chunkedArr = [];

      while (i < this.productList.length) {
        chunkedArr.push(this.productList.slice(i, i + this.columnsCount));
        i += this.columnsCount;
      }
      return chunkedArr;
    },
    columnsCount() {
      let count = 3;
      const screenWidth = screen.width;
      if (screenWidth === 768) {
        count = 2;
      }
      if (screenWidth <= 375) {
        count = 1;
      }
      return count;
    },
  },

  methods: {
    checkIfClassActive(tabname) {
      let currentUrl = window.location.pathname;
      let newurl = currentUrl.split('/');
      let tabnameAlle = newurl[2] == undefined && tabname == 'Alle';
      let tabnameMatch =
        this.productList[0].category.toLowerCase() == tabname.toLowerCase() &&
        newurl[2] != undefined;
      if (tabnameAlle || tabnameMatch) {
        return 'active';
      }
    },
  },
};
</script>
